import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SocietyInternalNav from './SocietyInternalNav';
import LoadingSpinner from '../common/LoadingSpinner';
import { societyService } from '../../services/societyService';
import { getSocietyHubPath } from '../../utils/societyHubNavigation';

/** Mobile sticky strip below header for society routes outside SocietyDetailPage. */
const SocietyContextMobileNav = ({ societySlug, activeSection }) => {
  const navigate = useNavigate();
  const [society, setSociety] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!societySlug) {
      setSociety(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    const load = async () => {
      try {
        const data = await societyService.getSociety(societySlug);
        if (!cancelled) setSociety(data);
      } catch (err) {
        console.error('SocietyContextMobileNav: failed to load society', err);
        if (!cancelled) setSociety(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [societySlug]);

  if (!societySlug) return null;

  const canonicalSlug = society?.slug ?? societySlug;

  const handleSectionChange = (section) => {
    const path = getSocietyHubPath(canonicalSlug, section);
    if (path) navigate(path);
  };

  const societyForNav = society ?? { slug: societySlug };

  return (
    <div className="lg:hidden sticky top-16 z-40 bg-white border-b shadow-sm">
      <div className="px-4 py-3">
        {loading ? (
          <div className="flex justify-center items-center min-h-[4.25rem]" aria-busy="true" aria-live="polite">
            <LoadingSpinner />
          </div>
        ) : (
          <SocietyInternalNav
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
            society={societyForNav}
          />
        )}
      </div>
    </div>
  );
};

export default SocietyContextMobileNav;
